import actions from '../index';
import analyticsActions from './analyticsActions';

export default function loadPage() {
  return dispatch => {
    dispatch(actions.setHomepage());
    dispatch(analyticsActions.homepageLoaded());
  };
}
